var TopicSelectorField;

TopicSelectorField = require('components/covid_extraction_form/topic_selector_field');

module.exports = {
  HANDOUT_FORM: {
    main: [
      {
        fieldKey: 'name',
        type: 'text',
        showClear: false,
        useControlledInput: true
      }, {
        fieldKey: 'parentTopic',
        type: 'custom',
        showClear: false,
        component: TopicSelectorField
      }
    ]
  }
};
